module.exports = __webpack_public_path__ + "img/图层_2.594fca56.png";